// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__vl9tc","title":"BackImages_title__1UI8j","images":"BackImages_images__2OFhm"};